import { render } from "./FullScreenLoader.vue?vue&type=template&id=e7c44d2e&ts=true"
import script from "./FullScreenLoader.vue?vue&type=script&lang=ts"
export * from "./FullScreenLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__